<div class="js-hide-on-fullscreen row p-b-10">
  <div class="col-sm-12">
    <h4 class="page-title">{{TR "Analyse"}}</h4>
  </div>
</div>
<div class="js-hide-on-fullscreen row charts-config">
  <div class="col-sm-12 col-md-8">
    <div id="h-periode" class="card-box clearfix">
      <div class="row">
        <div class="col-sm-12">
          <label>{{TR "Zeitraum"}}</label>
        </div>
      </div>
      <div class="row">
        <div class=" col-xs-11">
          <button class="btn btn-sm btn-white js-chart-time-backward btn-group" >
            <i class="fa fa-arrow-left"></i>
          </button>
          <input class="form-control input-daterange-timepicker input-sm css-time-range" type="text" id="timerange" name="daterange"></input>
          <button class="btn btn-sm btn-white js-chart-time-forward btn-group" >
            <i class="fa fa-arrow-right"></i>
          </button>
          <select id="js-predefined-timerange" class="selectpicker dropdown-width-100" data-style="btn btn-sm btn-white" data-empty="{{TR "Bitte wählen Sie einen Zeitraum aus"}}">
            {{#each periods}}
              <option value="{{name}}">{{text}}</option>
            {{/each}}
          </select>
        </div>
      </div>
    </div>
  </div>
  <div id="configuration-region" class="col-sm-12 col-md-4">
  </div>
</div>

<div class="js-chart-message-container">
</div>

<div class="chart-wrapper">
  <div class="chart-toolbar">
    <div class="btn-group">
      <button class="btn btn-sm btn-default js-chart-zoom-reset btn-group"  data-toggle="tooltip" data-placement="bottom" title="{{TR "Zoom zurücksetzen"}}">
        <i class="fa fa-undo"></i>
      </button>
      <button class="btn btn-sm btn-default js-chart-refresh btn-group" data-toggle="tooltip" data-placement="bottom" title="{{TR "Refresh"}}">
        <i class="fa fa-refresh"></i>
      </button>
      <button class="btn btn-sm btn-default js-chart-auto-refresh btn-group" data-toggle="tooltip" data-placement="bottom" title="{{TR "Auto-Refresh"}}">
        <i class="fa fa-history"></i>
      </button>
      <button id="js-toggle-fullscreen" class="btn btn-sm btn-primary" data-toggle="tooltip" data-placement="bottom" title="{{TR "Vollbild"}}">
        <i class="fa fa-arrows-alt"></i>
      </button>
    </div>
    <div class="btn-group">
      <button class="btn btn-sm btn-default js-chart-export btn-group"  data-toggle="tooltip" data-placement="bottom" title="{{TR "Als PNG speichern"}}">
        <i class="fa fa-save"></i>
      </button>
      <button class="btn btn-sm btn-default js-chart-export-csv btn-group"  data-toggle="tooltip" data-placement="bottom" title="{{TR "Als CSV speichern"}}">
        <i class="fa fa-table"></i>
      </button>
      <button class="btn btn-sm btn-default js-chart-copy-link btn-group" data-toggle="tooltip" data-placement="bottom" title="{{TR "Link kopieren"}}">
        <i class="fa fa-clipboard"></i>
      </button>
      <button class="btn btn-sm btn-default js-configure-chart btn-group" data-toggle="tooltip" data-placement="bottom" title="{{TR "Einstellung"}}">
        <i class="fa fa-cog"></i>
      </button>
    </div>
    {{#if canShowEvents}}
    <div class="btn-group">
      <button class="btn btn-sm btn-default js-chart-show-events btn-group {{#if showEvents}}btn-selected{{/if}}" data-toggle="tooltip" data-placement="bottom" title="{{TR "Ereignisanzeige"}}">
        <i class="fa fa-map-signs"></i>
      </button>
    </div>
    {{/if}}
    <div class="btn-group">
      <button class="btn btn-sm btn-default js-chart-reset-zoom btn-group" data-toggle="tooltip" data-placement="bottom" title="{{TR "Zoom anpassen"}}">
        <i class="fa fa-arrows"></i>
      </button>
    </div>
  </div>
  <div class="dygraph-legend-extern" id="chart-legend">
  </div>
  <div class="chart-container">
  </div>
</div>
